import {
  ADMIN_FETCH_COWS_REQUEST,
  ADMIN_FETCH_COWS_SUCCESS,
  ADMIN_FETCH_COWS_FAIL,
  ADMIN_FETCH_COW_REQUEST,
  ADMIN_FETCH_COW_SUCCESS,
  ADMIN_FETCH_COW_FAIL,
  ADMIN_ADD_COW_REQUEST,
  ADMIN_ADD_COW_SUCCESS,
  ADMIN_ADD_COW_FAIL,
  ADMIN_UPDATE_COW_REQUEST,
  ADMIN_UPDATE_COW_SUCCESS,
  ADMIN_UPDATE_COW_FAIL,
  ADMIN_DELETE_COW_REQUEST,
  ADMIN_DELETE_COW_SUCCESS,
  ADMIN_DELETE_COW_FAIL,
  ADMIN_REGISTER_REQUEST,
  ADMIN_REGISTER_SUCCESS,
  ADMIN_REGISTER_FAIL,
  ADMIN_CLEAR_REGISTRATION,
  ADMIN_SET_ANIMAL_SORT,
  ADMIN_SET_COW_PAGE,
  ADMIN_SET_COW_PAGE_SIZE,
  ADMIN_SET_PWD_REQUEST,
  ADMIN_SET_PWD_SUCCESS,
  ADMIN_SET_PWD_FAIL,
  ADMIN_SET_FILTER_ATTR,
  ADMIN_SET_FILTER_OPERATOR,
  ADMIN_SET_FILTER_VALUE
} from './constants';
import { createSelector } from 'reselect';
import sort from 'fast-sort';
import addDocumentsToScores from '../cows/util/addDocumentsToScores';
import { calculateScore } from './scoreDefinitions/util';
import { getOrgsObj } from './orgAdmin/reducer';
import { monthsFromDate } from '../util/datesAndAges';
import {
  getFilterAttribute,
  getFilterOperator,
  getFilterValue
} from './filterSelectors';
import { filterItemsFunctionCreator } from './util/filterItems';
import { USER_LOGOUT } from '../user/constants';

const initialState = {
  fetching: false,
  fetched: false,
  animals: {},
  fetchingAnimals: {},
  sortAttribute: 'id',
  sortAttributeInverted: false,
  registrationStatus: 'NOT-REGISTERING',
  registrationError: null,
  setPwdStatus: 'NOT-SETTING-PWD',
  setPwdError: null,
  animalPage: 1,
  animalPageSize: 20,
  filterAttribute: 'name',
  filterOperator: 'contains',
  filterValue: null
};

const admin = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGOUT:
      return { ...initialState };
    case ADMIN_FETCH_COWS_REQUEST:
      return { ...state, fetching: true };
    case ADMIN_FETCH_COWS_SUCCESS: {
      const animals = {};
      action.animals.forEach(animal => {
        animal.saved = true;
        animal.gbiScore = calculateScore(animal, action.scoreDefinitions);
        addDocumentsToScores(animal, action.scoreDefinitions);
        animals[animal.id] = animal;
        if (animal.lastUpdate && animal.lastUpdate.dateTime) {
          animals[animal.id].lastUpdateTime = animal.lastUpdate.dateTime;
        }
      });
      return { ...state, animals, fetching: false, fetched: true };
    }
    case ADMIN_FETCH_COWS_FAIL:
      return { ...state, fetching: false };
    case ADMIN_FETCH_COW_REQUEST: {
      const fetchingAnimals = { ...state.fetchingAnimals };
      fetchingAnimals[action.id] = true;
      return { ...state, fetchingAnimals };
    }
    case ADMIN_FETCH_COW_SUCCESS: {
      const animals = JSON.parse(JSON.stringify(state.animals));
      const fetchingAnimals = state.fetchingAnimals;
      delete fetchingAnimals[action.animal.id];
      animals[action.animal.id] = action.animal;
      animals[action.animal.id].saved = true;
      addDocumentsToScores(animals[action.animal.id], action.scoreDefinitions);
      if (action.animal.lastUpdate && action.animal.lastUpdate.dateTime) {
        animals[action.animal.id].lastUpdateTime =
          action.animal.lastUpdate.dateTime;
      }
      return { ...state, animals, fetchingAnimals };
    }
    case ADMIN_FETCH_COW_FAIL: {
      const fetchingAnimals = { ...state.fetchingAnimals };
      delete fetchingAnimals[action.id];
      return { ...state, fetchingAnimals };
    }
    case ADMIN_ADD_COW_REQUEST: {
      const animals = { ...state.animals };
      animals[action.animal.id] = action.animal;
      animals[action.animal.id].saving = true;
      return { ...state, animals };
    }
    case ADMIN_ADD_COW_SUCCESS: {
      const animals = { ...state.animals };
      animals[action.animal.id].saving = false;
      animals[action.animal.id].saved = true;
      return { ...state, animals };
    }
    case ADMIN_ADD_COW_FAIL: {
      const animals = { ...state.animals };
      animals[action.animal.id].saving = false;
      animals[action.animal.id].saved = false;
      return { ...state, animals };
    }
    case ADMIN_UPDATE_COW_REQUEST: {
      const animals = { ...state.animals };
      animals[action.animal.id] = action.animal;
      animals[action.animal.id].saving = true;
      return { ...state, animals };
    }
    case ADMIN_UPDATE_COW_SUCCESS: {
      const animals = { ...state.animals };
      animals[action.animal.id].saving = false;
      animals[action.animal.id].saved = true;
      return { ...state, animals };
    }
    case ADMIN_UPDATE_COW_FAIL: {
      const animals = { ...state.animals };
      animals[action.animal.id].saving = false;
      animals[action.animal.id].saved = false;
      return { ...state, animals };
    }
    case ADMIN_DELETE_COW_REQUEST: {
      const animals = { ...state.animals };
      delete animals[action.animal.id];
      return { ...state, animals };
    }
    case ADMIN_DELETE_COW_SUCCESS: {
      const animals = { ...state.animals };
      delete animals[action.animal.id];
      return { ...state, animals };
    }
    case ADMIN_DELETE_COW_FAIL: {
      const animals = { ...state.animals };
      animals[action.animal.id] = action.animal;
      return { ...state, animals };
    }
    case ADMIN_REGISTER_REQUEST:
      return { ...state, registrationStatus: 'REGISTERING' };
    case ADMIN_REGISTER_SUCCESS:
      return { ...state, registrationStatus: 'REGISTERED' };
    case ADMIN_REGISTER_FAIL:
      return {
        ...state,
        registrationStatus: 'FAILED',
        registrationError: action.error
      };
    case ADMIN_CLEAR_REGISTRATION:
      return {
        ...state,
        registrationStatus: 'NOT-REGISTERING',
        registrationError: null
      };
    case ADMIN_SET_ANIMAL_SORT: {
      const sortAttributeInverted =
        state.sortAttribute === action.sort ?
          !state.sortAttributeInverted : false;
      return { ...state,
        sortAttribute: action.sort,
        sortAttributeInverted,
        animalPage: 1 };
    }
    case ADMIN_SET_COW_PAGE: {
      return { ...state, animalPage: action.page };
    }
    case ADMIN_SET_COW_PAGE_SIZE: {
      return { ...state, animalPageSize: action.size };
    }
    case ADMIN_SET_PWD_REQUEST:
      return { ...state, setPwdStatus: 'SETTING-PWD' };
    case ADMIN_SET_PWD_SUCCESS:
      return { ...state, setPwdStatus: 'PWD-SET' };
    case ADMIN_SET_PWD_FAIL:
      return { ...state, setPwdStatus: 'FAILED', setPwdError: action.error };
    case ADMIN_SET_FILTER_ATTR:
      return { ...state,
        filterAttribute: action.filterAttribute,
        animalPage: 1 };
    case ADMIN_SET_FILTER_OPERATOR:
      return { ...state, filterOperator: action.filterOperator, animalPage: 1 };
    case ADMIN_SET_FILTER_VALUE:
      return { ...state, filterValue: action.filterValue, animalPage: 1 };
  }
  return state;
};

const fetching = state => state.admin.fetching;
const fetched = state => state.admin.fetched;
const fetchingAnimals = state => state.admin.fetchingAnimals;
const animals = state => state.admin.animals;
const sortAttribute = state => state.admin.sortAttribute;
const sortAttributeInverted = state => state.admin.sortAttributeInverted;
const registrationStatus = state => state.admin.registrationStatus;
const registrationError = state => state.admin.registrationError;
const setPwdStatus = state => state.admin.setPwdStatus;
const setPwdError = state => state.admin.setPwdError;
const animalPage = state => state.admin.animalPage;
const animalPageSize = state => state.admin.animalPageSize;

export const isFetching = createSelector(
  fetching, fetching => fetching
);

export const haveFetchedAnimals = createSelector(
  fetched, fetched => fetched
);

export const getAnimalsFetching = createSelector(
  fetchingAnimals, obj => obj
);

export const getAdminAnimalsObject = createSelector(
  animals, animals => animals
);

export const getAdminSortAttribute = createSelector(
  sortAttribute, attribute => attribute
);

export const getAdminSortAttributeInverted = createSelector(
  sortAttributeInverted, inverted => inverted
);

export const getAdminAnimals = createSelector(
  animals, animals => {
    const cowsList = Object.values(animals) || [];
    return cowsList;
  }
);

export const getAnimalsWithAges = createSelector(
  animals, animals => {
    const animalList = Object.values(animals) || [];
    return animalList.map(animal => {
      if (animal.dob) {
        animal.age = monthsFromDate(animal.dob);
      }
      return animal;
    });
  }
);

export const getAnimalsWithOrgs = createSelector(
  [getOrgsObj, getAnimalsWithAges], (orgs, animalList) => {
    return animalList.map(animal => {
      if (animal.orgId && orgs[animal.orgId] && orgs[animal.orgId].name) {
        animal.org = orgs[animal.orgId].name;
      }
      return animal;
    });
  }
);

const filterItems = filterItemsFunctionCreator([
  { attribute: 'name', operator: 'contains' },
  { attribute: 'tag', operator: 'contains' },
  { attribute: 'org', operator: 'contains' },
  { attribute: 'age', operator: 'greaterThanOrEquals' }
]);

export const getFilteredAnimals = createSelector(
  [getAnimalsWithOrgs, getFilterAttribute, getFilterOperator, getFilterValue],
  filterItems
);

export const getAnimalCount = createSelector(
  getFilteredAnimals, animals => animals.length
);

export const getSortedAdminAnimals = createSelector(
  [getFilteredAnimals, getAdminSortAttribute, getAdminSortAttributeInverted],
  (records, attribute, inverted) => {
    if (!attribute || typeof inverted !== 'boolean') return records;
    return inverted ?
      sort(records.slice()).asc(attribute) :
      sort(records.slice()).desc(attribute);
  }
);

export const getPageOfAdminAnimals = createSelector(
  [getSortedAdminAnimals, animalPage, animalPageSize],
  (animals, page, size) => {
    const start = (page - 1) * size;
    const end = page * size;
    return animals.slice(start, end);
  }
);

export const getRegistrationStatus = createSelector(
  registrationStatus, status => status
);

export const getRegistrationError = createSelector(
  registrationError, error => error
);

export const getSetPwdStatus = createSelector(
  setPwdStatus, status => status
);

export const getSetPwdError = createSelector(
  setPwdError, error => error
);

export const getAdminAnimalCount = createSelector(
  getAdminAnimals, animals => animals.length
);

export const getAnimalPage = createSelector(
  animalPage, page => page
);

export const getAnimalPageSize = createSelector(
  animalPageSize, size => size
);

export default admin;
